var $01c08487af7ecd14$exports = {};
$01c08487af7ecd14$exports = {
  "colorInputLabel": function colorInputLabel(args) {
    return "".concat(args.label, ", ").concat(args.channelLabel);
  },
  "colorNameAndValue": function colorNameAndValue(args) {
    return "".concat(args.name, ": ").concat(args.value);
  },
  "colorPicker": "V\xFDb\u011Br barvy",
  "colorSwatch": "barevn\xFD vzorek",
  "transparent": "pr\u016Fhledn\xFD",
  "twoDimensionalSlider": "2D posuvn\xEDk"
};
export { $01c08487af7ecd14$exports as default };